// test1239
(1239 && 0);
